<template>
  <footer>
    <div class="inner">
      <div class="container">
        <div class="left-content">
          <ul>
            <li v-for="(qaItem, qaIndex) in compQaList" :key="'qa' + qaIndex">
              <p class="inquiry underline" @click="moveInqury(qaItem)">
                {{ qaItem.courseName }} 1:1 문의하기
              </p>
              <p class="manager-info">{{ qaItem.qaManager }}</p>
            </li>
          </ul>
          <div>
            <p v-if="isFaq === 'Y'" @click="movePage('/common/faq')">FAQ</p>
          </div>
        </div>
      </div>
    </div>
    <p class="copyright">Copyright (c)CARROT. All Rights Reserved</p>
  </footer>
  <ItmInquiry
    :visible="itmInquiryVisible"
    @closeModal="onCloseModal"
    :pageIdx="onPageIdx"
  ></ItmInquiry>
</template>

<script>
import { computed, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import { channelUrl } from "@/plugins/apiUrl";
import ItmInquiry from "./ItmInquiry.vue";
import { useRouter } from "vue-router";
export default {
  components: {
    ItmInquiry,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const itmInquiryVisible = ref(false);
    const onPageIdx = ref("-1");
    const isFaq = store.getters.getisFaq;
    const onCloseModal = () => {
      itmInquiryVisible.value = false;
    };

    onMounted(() => {});

    const compQaList = computed(() => {
      return store.getters.getFooterInfo["qaList"];
    });

    const moveInqury = (item) => {
      const { courseType, itmPageIdx } = item;
      if (courseType === "ctm") {
        window.open(channelUrl, "_blank");
      } else {
        onPageIdx.value = itmPageIdx;
        itmInquiryVisible.value = true;
      }
    };

    const movePage = (path) => {
      router.push(path);
    };

    return {
      itmInquiryVisible,
      onPageIdx,
      onCloseModal,
      compQaList,
      moveInqury,
      movePage,
      isFaq,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/style.scss";

footer {
  background-color: #333333;
}

.inner {
  display: flex;
  flex-direction: column;
  padding: 52px 0;
  background-color: #333333;
  border-bottom: 1px solid #484848;
}

.left-content {
  display: flex;
  justify-content: space-between;
  gap: 0 27px;

  > div p {
    font-size: 17px;
    font-weight: $bold;
    color: #a6a6a6;
    padding: 10px 40px;
    border: 1px solid #a6a6a6;
    cursor: pointer;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 10px 0;

    li {
      display: flex;
      gap: 0 15px;
      font-size: 15px;
    }
  }
}

.manager-info {
  color: #7f7f7f;
}

.inquiry {
  font-weight: $medium;
  color: $blue;
  cursor: pointer;
}

.copyright {
  color: #7f7f7f;
  text-align: center;
  padding: 26px 0;
  font-size: 15px;
}
</style>
